import { render, staticRenderFns } from "./attendanceRecord.vue?vue&type=template&id=070c1f51"
import script from "./attendanceRecord.vue?vue&type=script&lang=js"
export * from "./attendanceRecord.vue?vue&type=script&lang=js"
import style0 from "./attendanceRecord.vue?vue&type=style&index=0&id=070c1f51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports